module.exports = __webpack_public_path__ + "img/A8.cfdbf0db.svg";